export enum LoadingType {
    LOADING = "loading",
    ERROR = "error"
}